import { getLayoutViewportSize } from './pageZoom';

/** 튜토리얼은 PC(가로 900px 이상)에서만 지원 */
export const TUTORIAL_MIN_VIEWPORT_WIDTH = 900;

export const TUTORIAL_DESKTOP_ONLY_MESSAGE =
  '튜토리얼은 가로 900px 이상의 PC 화면에서만 이용할 수 있어요. 창을 넓히거나 PC에서 다시 시도해 주세요.';

/** layout 뷰포트 가로가 최소 너비 이상인지 (화면 배율 보정 포함) */
export function isTutorialDesktopViewport(): boolean {
  if (typeof window === 'undefined') return true;
  return getLayoutViewportSize().width >= TUTORIAL_MIN_VIEWPORT_WIDTH;
}
